import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ResizeThumb } from '../ResizeThumb';
import { RESIZE_THUMB_POSITIONS } from '../../../constants';

const ResizeBorder = React.forwardRef(({ block, isVisible, children, onPointerDown = () => {} }, ref) => {
    const { 'margin-left': indent } = Object.fromEntries(block.getData());

    const resizeBorderClasses = classNames('onsolve-wysiwyg-editor__resize-border', {
        'onsolve-wysiwyg-editor__resize-border--visible': isVisible,
        [`onsolve-wysiwyg-editor__${indent}`]: !!indent
    });

    return (
        <span className={resizeBorderClasses} ref={ref}>
            {children}
            {isVisible &&
                Object.values(RESIZE_THUMB_POSITIONS).map(position => (
                    <ResizeThumb key={position} position={position} onPointerDown={onPointerDown} />
                ))}
        </span>
    );
});

ResizeBorder.propTypes = {
    block: PropTypes.object.isRequired,
    children: PropTypes.node,
    isVisible: PropTypes.bool,
    onPointerDown: PropTypes.func
};

ResizeBorder.displayName = 'ResizeBorder';

export default ResizeBorder;
